<template>
    <div class="fzg-chuangtou-mobile">
      <div class="fzg-banner">
        <fzg-menu/>
        <img class="m-banner" src="../../assets/img2/mobile/invest/banner.jpg" alt="">
        <!-- <img class="m-intro" src="../../assets/img2/mobile/invest/intro.jpg" alt=""> -->
        <img class="m-intro" src="https://static-image.xfz.cn/1698581100360/chuangtou_mobile.jpg">
      </div>

      <div class="fzg-ct-case-list">
        <img class="case-title" src="../../assets/img2/pc/chuangtou/title-al.png" >
        <ul class="bus-wrap">
          <li class="bus-item" v-for="item in invest_case_list">
            <div class="cover">
              <div class="cover-content"> {{ item.brief }} </div>
            </div>
            <img class="logo" :src="item.logo" alt="">
            <div class="name">{{ item.name }}</div>
          </li>
          <template v-if="false">
            <li class="bus-item">
              <div class="cover">
                <div class="cover-content"> 新一代经营门店经营系统，助力商家数字化升级 </div>
              </div>
              <img class="logo" src="../../assets/img2/pc/chuangfu/logo10.png" alt="">
              <div class="name">人才对接</div>
            </li>
          </template>
        </ul>

      </div>

      <!-- 公司列表 -->
      <div class="fzg-company-list">
        <div class="company-list-title">
          <img src="../../assets/img2/pc/chuangtou/title-bt.png" alt="">
        </div>
        <div class="fzg-company-list-wrap">
          <div class="fzg-company-list-item-wrap"
            v-for="(item,index) in invest_company_list"
            v-if="isShowMoreCompany ? true : index < 7"
            :class="{ 'active-company' : activeCompanyId == item.id}">
            <div class="fzg-citem"
              @click="activeCompanyId = item.id">
              <div class="citem-name">
                <div class="c-title"> {{item.name}} </div>
              </div>
              <div class="c-item-content">
                <div class="c-item-image">
                  <img :src="item.logo" >
                </div>
                <div class="c-item-intro">
                  <p>{{item.brief }}</p>
                  <div class="c-item-link">
                    <a :href="item.link" target="_blank"> 查看企业 </a>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isShowMoreCompany" class="check-more" @click="isShowMoreCompany = true"> 更多 </div>
        </div>
      </div>

    </div>
</template>

<script>

import util from '../../assets/js/util'
import FzgMenu from '../common/FzgMenuMobile.vue'

export default{
    components:{
      FzgMenu
    },
    props:[''],
    data(){
      return {
        invest_case_list: [],
        invest_company_list: [],
        activeCompanyId: 1,
        isShowMoreCompany: false,
      }
    },
    methods:{
      getInvestCaseList() {
        var self = this
        util.resource({
            url: '/api/fzg/invest_cases/',
            method: 'get',
            data: {
              n: 200
            },
            success (res) {
              if (res.code == 200) {
                self.invest_case_list = res.data.list
              }
            }
        })
      },
      // invested_company
      getInvestCompanyList() {
        var self = this
        util.resource({
            url: '/api/fzg/invested_company/',
            method: 'get',
            success (res) {
              if (res.code == 200) {
                self.invest_company_list = res.data.list
                if (self.invest_company_list.length > 0) {
                  self.activeCompanyId = self.invest_company_list[0].id
                }
              }
            }
        })
      },
    },
    mounted(){
      this.getInvestCaseList()
      this.getInvestCompanyList()
    },
    watch: {
    },

}
</script>

<style lang="scss">
.fzg-chuangtou-mobile {
  .fzg-banner {
    // border: 1px solid red;
    // background: url(../../assets/img2/pc/chuangtou/banner.png) no-repeat;
    // background: url(https://static-image.xfz.cn/1686266423456/ct-bn.png) no-repeat;
    .m-banner {
      width: 100%;
    }
    .m-intro {
      width: 100%;
    }
  }


  .fzg-ct-case-list {
    // border: 1px solid green;
    // background: #f6f9ff;
    padding-top: 30px;
    padding-bottom: 40px;
    position: relative;
    .case-title {
      // border: 1px solid red;
      width: 120px;
      display: block;
      margin: 0 auto;
    }
    .bus-wrap {
      // border: 1px solid red;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      margin-top: 20px;
      padding-left: 3px;
      border-collapse: collapse;
      // border-spacing: 4px;
      .bus-item {
        border: 1px solid #ededed;
        list-style-type: none;
        text-align: center;
        width: 33.333%;
        margin-left: -1px;
        position: relative;
        .logo {
          margin-top: 10px;
          // border: 1px solid #ccc;
          height: 80px;
        }
        .name {
          // border: 1px solid #ccc;
          margin-top: 10px;
          margin-bottom: 10px;
          font-size: 13px;
          color: #444444;
        }
        .cover {
          visibility: hidden;
          opacity: 0;
          position: absolute;
          transition: visibility 0s, opacity 0.36s linear;
          border-radius: 2px;
          text-align: left;
          height: 100%;
        }

        &:hover {
          cursor: pointer;
          .cover {
            position: absolute;
            visibility: visible;
            width: 100%;
            height: 100%;
            background-color: #ad2027;
	          opacity: 0.87;
            display: flex;
            align-items: center;
            .cover-content {
              // border: 1px solid #ccc;
              font-size: 14px;
              padding: 20px;
              color: white;
            }
          }
        }
      }
      .bus-item:nth-child(n + 6) {
        margin-top: -2px;
      }
    }
  }

  .fzg-company-list {
    // border: 1px solid green;
    overflow: auto;
    position: relative;
    .company-list-title {
      // border: 1px solid red;
      img {
        width: 120px;
        display: block;
        margin: 0 auto;
      }
    }
    .fzg-company-list-wrap {
      margin-top: 60px;
      margin-bottom: 100px;
      padding: 20px;
      .fzg-company-list-item-wrap {
        // border: 1px solid green;
        margin: 0px auto 0;
        width: 100%;
        .fzg-citem {
          border-bottom: 1px solid #ccc;
          cursor: pointer;
          .citem-name {
            background: white;
            height: 50px;
            line-height: 50px;
            .c-title{
              // border: 1px solid red;
              display: inline-block;
              color: #424242;
              font-size: 16px;
              padding-left: 20px;
              width: 100%;

              white-space:nowrap;
              overflow:hidden;
              text-overflow: ellipsis;
            }
          }
          .c-item-content {
            // display: none;
            opacity: 0;
            overflow: hidden;
            height: 0px;
            // transition: height 0.3s ease-in, opacity .2s linear;
            transition: height 0.3s ease, opacity .4s linear;
            .c-item-image {
              // border: 1px solid #ccc;
              display: inline-block;
              margin-top: 30px;
              margin-bottom: 10px;
              overflow: hidden;
              width: 300px;
              img {
                // border: 1px solid #ccc;
                display: block;
                width: 200px;
                margin-left: 10px;
              }
            }
            .c-item-intro {
              // border: 1px solid #ccc;
              display: inline-block;
              vertical-align: top;
              width: 100%;
              padding: 20px;
              font-size: 14px;
              line-height: 1.8;
              color: #898989;
              text-align: justify;
              white-space: break-spaces;
              .c-item-title {
                font-size: 16px;
                color: #444444;
                margin-bottom: 10px;
              }
              .c-item-link{
                font-size: 14px;
                color: #444444;
                border :1px solid #ccc;
                display: inline-block;
                padding: 2px 25px;
                border-radius: 20px;
                margin-top: 20px;
                margin-left: -5px;
                font-size: 15px;
              }
            }
          }

        }
          &:first-child { // last fzg-citem
            border-top: 1px solid #ccc;
          }
      }
      .check-more {
        width: 120px;
        margin: 40px auto 0;
        border: 1px solid #ccc;
        text-align: center;
        padding: 6px 0;
        border-radius: 20px;
        cursor: pointer;
      }

      .active-company {
        .citem-name {
          background:#444444 !important;
          .c-title{
            color: white !important;
          }
        }
        .c-item-content {
          opacity: 1 !important;
          display: block !important;
          height: auto !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// FzgChuangTouMobile.vue?82c791d8